<template>
  <div>
    <Form
      style="margin: 30px 20px"
      :model="formItem"
      :label-width="100"
      label-position="left"
    >
      <Row>
        <Col :xs="24" :sm="24" :md="11" :lg="6">
          <FormItem label="员工姓名:">
            <Input v-model="searchItem.userName" :disabled="loading" />
          </FormItem>
        </Col>
        <Col
          :xs="{ span: 24, offset: 0 }"
          :lg="{ span: 6, offset: 1 }"
          :sm="{ span: 24, offset: 0 }"
          :md="{ span: 11, offset: 1 }"
        >
          <FormItem label="状态：">
            <Select
              v-model="searchItem.status"
              :disabled="loading"
              :clearable="true"
              placeholder=""
            >
              <Option :value="item.value" v-for="(item, i) in SList" :key="i"
                >{{ item.label }}
              </Option>
            </Select>
          </FormItem>
        </Col>
        <Col :lg="{ span: 2, offset: 1 }" :xs="6" :sm="6" :md="2">
          <Button type="primary" @click="getData" :disabled="loading"
            ><!-- 检索 -->{{ $t("Search") }}</Button
          >
        </Col>
        <Col
          :xs="{ span: 6, offset: 1 }"
          :sm="{ span: 6, offset: 1 }"
          :md="{ span: 2, offset: 1 }"
          :lg="2"
        >
          <Button type="primary" @click="switchClick" :disabled="loading"
            >切换</Button
          >
        </Col>
      </Row>
    </Form>
    <Card style="margin-top: 20px">
      <Table
        border
        ref="table"
        :loading="loading"
        :columns="columns"
        :data="tableData"
        width="100%"
        stripe
      >
        <template slot-scope="{ row, index }" slot="action">
          <Button
            type="primary"
            size="small"
            @click="OnboardingEdit(row, index)"
            >编辑</Button
          >
          <Button
            type="primary"
            size="small"
            @click="goPage(row, index)"
            style="margin-left:20px"
            >查看</Button
          >
        </template>
      </Table>
      <Row style="margin-top:15px">
        <Col span="19">
          <Page
            :total="total"
            :page-size="pageInfo.pageSize"
            @on-change="pageChange"
          />
        </Col>
      </Row>
    </Card>

    <Modal v-model="showModal" :disabled="prevent" title="编辑">
      <Form :label-width="160" label-position="left">
        <Row>
          <Col span="24">
            <FormItem label="员工姓名">
              <Input
                style="display:inline;width:100%"
                disabled
                v-model="taskForm.userName"
              ></Input>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="【1】录用发起">
              <Select
                clearable
                v-model="taskForm.employmentInitiationTask"
                placeholder=""
                :disabled="formItem.employmentInitiationTask == 0"
              >
                <Option
                  v-for="(item, index) in SList"
                  :value="item.value"
                  :key="index"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="【2】录用审批">
              <Select
                clearable
                v-model="taskForm.employmentApprovalTask"
                placeholder=""
                :disabled="formItem.employmentApprovalTask == 0"
              >
                <Option
                  v-for="(item, index) in SList"
                  :value="item.value"
                  :key="index"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="【3】附件生成">
              <Select
                clearable
                v-model="taskForm.generateAttachmentTask"
                placeholder=""
                :disabled="formItem.generateAttachmentTask == 0"
              >
                <Option
                  v-for="(item, index) in SList"
                  :value="item.value"
                  :key="index"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="【4】提交个人资料">
              <Select
                clearable
                v-model="taskForm.sumitPersonalMeterialTask"
                placeholder=""
                :disabled="formItem.sumitPersonalMeterialTask == 0"
              >
                <Option
                  v-for="(item, index) in SList"
                  :value="item.value"
                  :key="index"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="【5】信息确认">
              <Select
                clearable
                v-model="taskForm.confirmInformationTask"
                placeholder=""
                :disabled="formItem.confirmInformationTask == 0"
              >
                <Option
                  v-for="(item, index) in SList"
                  :value="item.value"
                  :key="index"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="【6】行政准备">
              <Select
                clearable
                v-model="taskForm.administrationPlanTask"
                placeholder=""
                :disabled="formItem.administrationPlanTask == 0"
              >
                <Option
                  v-for="(item, index) in SList"
                  :value="item.value"
                  :key="index"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="【7】资料生成">
              <Select
                clearable
                v-model="taskForm.generateMeterialTask"
                placeholder=""
                :disabled="formItem.generateMeterialTask == 0"
              >
                <Option
                  v-for="(item, index) in SList"
                  :value="item.value"
                  :key="index"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" @click="cancel()">取消</Button>
        <Button type="primary" @click="save()">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
var StatusLabel = function(value) {
  if (value == 0) {
    return "已完成";
  } else if (value == 1) {
    return "待处理";
  } else if (value == 2) {
    return "处理中";
  } else if (value == 3) {
    return "未开启";
  }
};
export default {
  data() {
    return {
      searchItem: {},
      loading: false,
      pageInfo: {
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      tableData: [],
      SList: [
        { value: "0", label: "已完成" },
        { value: "1", label: "待处理" },
        { value: "2", label: "处理中" },
        { value: "3", label: "未开启" }
      ],
      textStatus: false,
      prevent: false,
      showModal: false,
      taskForm: {},
      formItem: {}
    };
  },
  computed: {
    columns() {
      return [
        {
          title: "单号",
          key: "applyNo",
          minWidth: 160
        },
        {
          title: "员工姓名",
          key: "userName",
          minWidth: 160
        },
        {
          title: "【1】录用发起",
          key: "employmentInitiationTask",
          align: "center",
          render: (h, params) => {
            return this.rowStatus(h, params.row.employmentInitiationTask);
          },
          minWidth: 160
        },
        {
          title: "【2】录用审批",
          key: "employmentApprovalTask",
          align: "center",
          render: (h, params) => {
            return this.rowStatus(h, params.row.employmentApprovalTask);
          },
          minWidth: 160
        },
        {
          title: "【3】附件生成",
          key: "generateAttachmentTask",
          align: "center",
          render: (h, params) => {
            return this.rowStatus(h, params.row.generateAttachmentTask);
          },
          minWidth: 160
        },
        {
          title: "【4】提交个人资料",
          key: "sumitPersonalMeterialTask",
          align: "center",
          render: (h, params) => {
            return this.rowStatus(h, params.row.sumitPersonalMeterialTask);
          },
          minWidth: 160
        },
        {
          title: "【5】信息确认",
          key: "confirmInformationTask",
          align: "center",
          render: (h, params) => {
            return this.rowStatus(h, params.row.confirmInformationTask);
          },
          minWidth: 160
        },
        {
          title: "【6】行政准备",
          key: "administrationPlanTask",
          align: "center",
          render: (h, params) => {
            return this.rowStatus(h, params.row.administrationPlanTask);
          },
          minWidth: 160
        },
        {
          title: "【7】资料生成",
          key: "generateMeterialTask",
          align: "center",
          render: (h, params) => {
            return this.rowStatus(h, params.row.generateMeterialTask);
          },
          minWidth: 160
        },
        {
          title: "操作",
          slot: "action",
          width: 160,
          fixed: "right",
          align: "center"
        }
      ];
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      let Obj = {
        ...this.searchItem,
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize
      };
      axios.post("/ApplyOnboarding/selectOnboardTaskInfo", Obj).then(res => {
        this.tableData = res.data;
        this.total = parseInt(res.pageInfo.total);
        this.loading = false;
      });
    },
    rowStatus(h, key) {
      if (this.textStatus) {
        return h("span", StatusLabel(key));
      } else {
        if (key == 0 || key == 3) {
          let status = key;
          return h("div", [
            h("Icon", {
              style: {
                color: status == 0 ? "#19be6b" : "#666666"
              },
              props: {
                size: "18",
                type:
                  status == 0
                    ? "md-checkmark-circle-outline"
                    : "ios-remove-circle-outline"
              }
            }),
            h(
              "span",
              {
                style: {
                  color: status == 0 ? "#19be6b" : "#666666",
                  marginLeft: "6px"
                }
              },
              StatusLabel(key)
            )
          ]);
        } else if (key == 1 || key == 2) {
          return h(
            "Button",
            {
              props: {
                type: "warning",
                icon: "md-clock",
                loading: key == 2 ? true : false,
                size: "small"
              }
            },
            StatusLabel(key)
          );
        }
      }
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    },
    switchClick() {
      this.textStatus = !this.textStatus;
    },
    OnboardingEdit(row, index) {
      this.taskForm = JSON.parse(JSON.stringify(row));
      this.formItem = JSON.parse(JSON.stringify(row));
      this.showModal = true;
    },
    cancel() {
      this.showModal = false;
    },
    save() {
      this.$Modal.confirm({
        title: this.$notice("sureSave"),
        onOk: () => {
          let obj = {
            ...this.taskForm
          };
          axios
            .post("/ApplyOnboarding/updateOnboardTaskInfo", obj)
            .then(res => {
              this.getData();
            });
          this.showModal = false;
        }
      });
    },
    goPage(row, index) {
      this.$router.push({
        path:
          "/EA05DA2E97A25C31C712A46B53045412BA610C6A6F738319/A3FFBEBFDB713E27",
        query: { instanceId: row.instanceId, history: 1 }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/MyQuery/OnboardingTask.vue